import { useApp } from "contexts/BookingContext";
import React, { useEffect, useRef } from "react";
import Swal from "sweetalert2";

const PrintBookingDetails = ({
  booking,
  agent,
  refetch,
  onSuccess,
  onError,
}) => {
  const printRef = useRef();
  // const { refetch, sessions } = useApp();

  console.log("PrintBookingDetailsbooking", booking);

  const handlePrintvOld = () => {
    const printContent = printRef.current;
    if (!printContent) return;

    Swal.fire({
      title: "Konfirmasi Cetak",
      text: "Apakah Anda yakin ingin mencetak detail booking dan komisi?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ya, Cetak!",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        const originalContent = document.body.innerHTML;
        document.body.innerHTML = printContent.innerHTML;
        window.print();
        document.body.innerHTML = originalContent;
        // window.location.reload();

        // Swal.fire({
        //   title: "Sedang Mencetak",
        //   text: "Struk Anda sedang diproses...",
        //   icon: "success",
        //   timer: 1500,
        //   showConfirmButton: false,
        // });

        Swal.fire({
          title: "Sedang Mencetak",
          text: "Struk Anda sedang diproses...",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          onSuccess(); // Pastikan tidak langsung menutup komponen sebelum print selesai
        });
      } else {
        Swal.fire({
          title: "Dibatalkan",
          text: "Cetak struk dibatalkan.",
          icon: "info",
          timer: 1500,
          showConfirmButton: false,
        });
        // close canvas
        onError();
        refetch();
      }
    });
  };

  const handlePrintvold2 = () => {
    const printContent = printRef.current;
    if (!printContent) return;

    Swal.fire({
      title: "Konfirmasi Cetak",
      text: "Apakah Anda yakin ingin mencetak?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Cetak!",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        const printWindow = window.open("", "_blank");
        printWindow.document.write(`
          <html>
            <head>
              <title>Cetak</title>
              <style>
                @media print {
                  body { font-family: Arial, sans-serif; width: 48mm; }
                  .printable { display: block !important; }
                }
              </style>
            </head>
            <body>${printContent.innerHTML}</body>
          </html>
        `);
        printWindow.document.close();
        printWindow.print();
        printWindow.close();

        Swal.fire("Sedang Mencetak", "Struk sedang diproses...", "success");
        onSuccess();
      }
    });
  };

  const handlePrint = () => {
    const printContent = printRef.current;
    if (!printContent) {
      console.error("printRef tidak ditemukan");
      return;
    }

    Swal.fire({
      title: "Konfirmasi Cetak",
      text: "Apakah Anda yakin ingin mencetak?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Cetak!",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        const printWindow = window.open("", "_blank");
        // tanpa new window gunakan disii saja
        // const printWindow = window;
        if (!printWindow) {
          console.error("Jendela cetak gagal dibuka");
          return;
        }
        printWindow.document.write(`
          <html>
            <head>
              <title>Cetak</title>
              <style>
                @media print {
                  body { font-family: Arial, sans-serif; width: 48mm; }
                  .printable { display: block !important; }
                }
              </style>
            </head>
            <body>${printContent.innerHTML}</body>
          </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
          printWindow.print();
          printWindow.close();
          Swal.fire("Sedang Mencetak", "Struk sedang diproses...", "success");
          onSuccess();
        }, 500); // Beri jeda untuk memastikan rendering selesai
      } else {
        Swal.fire({
          title: "Dibatalkan",
          text: "Cetak struk dibatalkan.",
          icon: "info",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          onSuccess();
        });
        refetch();
      }
    });
  };

  useEffect(() => {
    if (!hasPrinted.current && booking) {
      handlePrint();
      hasPrinted.current = true;
    }
  }, [booking]);

  // useEffect(() => {
  //   console.log("PrintBookingDetailsbooking", booking);
  //   handlePrint();
  // }, [booking]);

  const hasPrinted = useRef(false);

  // useEffect(() => {
  //   if (!hasPrinted.current) {
  //     handlePrint();
  //     hasPrinted.current = true;
  //   }
  // }, []);
  useEffect(() => {
    if (!hasPrinted.current && booking) {
      handlePrint();
      hasPrinted.current = true;
    }
  }, [booking]);

  return (
    <div>
      {/* Konten yang akan dicetak */}
      <div
        ref={printRef}
        className="printable card border rounded shadow-sm"
        style={{ display: "none" }}
      >
        <style>
          {`
          @media print {
            body {
              font-family: Arial, sans-serif;
              width: 48mm;
              padding: 0;
            }
            .printable {
              display: block !important;
              width: 100%;
              padding: 10px;
              box-sizing: border-box;
              border: 1px solid #000; /* Border keliling untuk cetakan */
              border-radius: 4px; /* Sudut melengkung */
            }
            .card-header {
              text-align: center;
              font-size: 14px;
              margin-bottom: 8px;
            }
            .card-body p {
              font-size: 10px;
              margin: 4px 0;
              line-height: 1.2;
            }
            .border-top {
              border-top: 1px solid #000;
              margin: 8px 0;
            }
            .border-dashed {
              border-top: 1px dashed #000;
              margin: 8px 0;
            }
          }
          `}
        </style>

        {/* Logo */}
        <div className="text-center">
          <img
            src="/Kuber.jpeg"
            alt="Logo Perusahaan"
            style={{ width: "80px", height: "auto" }}
          />
        </div>

        {/* Header */}

        {/* <div className="text-center">
          <p>KUBER BALI ADVENTURE</p>
        </div> */}

        {/* Detail Booking */}
        <div className="card-body text-center">
          <p>KUBER BALI ADVENTURE</p>

          <p className="text-center upercase">
            Br. Bayad, Desa Melinggih kelod, payangan , Gianyar , Bali 80572
          </p>
        </div>
        <div className="border-dashed"></div>

        {/* <div className="border-dashed"></div> */}

        <div className="card-body">
          {/* <p>
            <strong>Tanggal Booking:</strong> {booking.reservation_date}
          </p>
          <p>
            <strong>Kode Booking:</strong> {booking.code}
          </p> */}
          <p>
            {booking.code}/{booking.reservation_date}/namakasir
          </p>
          <p>
            <strong>Nama Tamu:</strong> {booking.guest_name}
          </p>
          <p>
            <strong>Nama Agen:</strong> {agent?.name || "N/A"}
          </p>
          <p>
            <strong>TRIP:</strong> A/B
          </p>
          <p>
            <strong>Activity:</strong>
          </p>
          <ul
            style={{
              margin: 0,
              paddingLeft: "15px",
              fontSize: "10px",
              lineHeight: "1.4",
            }}
          >
            {booking.activities.map((activity, index) => (
              <li key={index}>
                <strong>{activity.activity}</strong>: {activity.qty} pax
              </li>
            ))}
          </ul>

          <p>
            <strong>Total Tamu:</strong> {booking.guest_pax}
          </p>

          <p>
            <strong>Total Bayar:</strong> Rp.{" "}
            {parseInt(booking.total_price).toLocaleString("id-ID")}
          </p>
        </div>
        <div className="border-dashed"></div>

        {/* Footer */}
        <div className="card-body text-center">
          <p className="text-bold">
            Terima kasih telah menggunakan layanan kami!
          </p>
        </div>
        <div className="border-dashed"></div>
      </div>
    </div>
  );
};

export default PrintBookingDetails;
